/* ***** ----------------------------------------------- ***** **
/* ***** Custom Scripts
/* ***** ----------------------------------------------- ***** */

if (document.body.classList.contains('template-index')) {
  const header = document.querySelector('.header')
  window.addEventListener('scroll', () => {
    if (window.scrollY <= 10) {
      header.classList.add('header--has-large-logo')
    } else {
      header.classList.remove('header--has-large-logo')
    }
  })
}